import { render } from "./Terminal.vue?vue&type=template&id=3e20f746&scoped=true"
import script from "./Terminal.vue?vue&type=script&lang=js"
export * from "./Terminal.vue?vue&type=script&lang=js"

import "./Terminal.vue?vue&type=style&index=0&id=3e20f746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e20f746"]])

export default __exports__